<template>
  <div id="dashboard">
    <v-layout class="row wrap">
      <v-flex class="xs12">
        <v-btn @click="addVisitors(48)">+48</v-btn>
        <v-btn @click="addVisitors(1)">+1</v-btn>
        <pre>{{ $store.state._StoreWatcheeBox.listeAllVisiteurs.length }}</pre>
      </v-flex>
    </v-layout>
    <v-btn fab @click="addNotif('info')" color="info">
      <v-icon>add</v-icon>
    </v-btn>
    <v-btn fab @click="addNotif('warning')" color="warning">
      <v-icon>add</v-icon>
    </v-btn>
    <v-btn fab @click="addNotif('error')" color="error">
      <v-icon>add</v-icon>
    </v-btn>
    <v-btn fab @click="addNotif('success')" color="success">
      <v-icon>add</v-icon>
    </v-btn>
    <v-btn icon @click="CLEAR()" large>
      <v-icon>delete</v-icon>
    </v-btn>
    <v-btn icon @click="HIDE()" large>
      <v-icon>visibility_off</v-icon>
    </v-btn>
    <pre>{{ index }}</pre>
    <pre>{{ $store.state._Notifier }}</pre>
  </div>
</template>

<script>
import _ from 'lodash'
import {mapGetters, mapMutations, mapActions} from 'vuex'
export default {
  data () {
    return {
      sheet: false,
      interval: null,
      txt: ''
    }
  },
  methods: {
    ...mapMutations('_Notifier', ['CLEAR']),
    ...mapActions('_Notifier', ['HIDE']),
    addVisitors (nb) {
      for (var i = 0; i < nb; i++) {
        let id = _.uniqueId()
        this.$store.commit('_StoreWatcheeBox/SOCKET_NEW_VISITEUR', {
          newVisiteur: [
            'visiteur',
            id,
            id,
            1,
            0,
            '4528',
            'online',
            'FR',
            id,
            '',
            2,
            2,
            'azerty',
            '#ziLeCXG9SwBsZL9nAAAE',
            '54.76.102.32',
            0,
            '',
            '',
            '',
            '',
            '',
            '',
            ''
          ],
          entId: this.$store.state._User.entId,
          maxVisitors: this.$store.state._User.maxVisitors,
          listAllSiteID: ['4528']
        })
      }
    },
    addNotif (context) {
      this.$store.dispatch('_Notifier/NEW_NOTIF', {
        message: 'nouvelle notification',
        context: context
      })
    }
  },
  computed: {
    ...mapGetters('_Notifier', ['index'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue